import axiosInstance from './axiosInstance';

export function isAdmin() {
  return axiosInstance.get('/admin');
}

export function missions(params) {
  return axiosInstance.get('/admin/missions', { params });
}

export function singleMission(missionId, params) {
  return axiosInstance.get(`/missions/${missionId}`, { params });
}

export function singleMissionStats(missionId, params) {
  return axiosInstance.get(`/missions/${missionId}/stats`, { params });
}

export function singleMissionChecks(missionId, params) {
  return axiosInstance.get(`/missions/${missionId}/checks`, { params });
}

export function singleCheck(checkId, params) {
  return axiosInstance.get(`/checks/${checkId}`, { params });
}

export default {
  isAdmin,
  missions,
  singleMission,
  singleMissionStats,
  singleMissionChecks,
  singleCheck,
};
